import React, { useEffect } from 'react';
import FeaturesSection from './FeaturesSection';
import SignUpSection from './SignUpSection';
import { useSignUpContext } from '../SignUpContext';
import './DirectSignUpPage.scss';

const DirectSignUpPage = () => {
    const { setIsDirectSignUpFlow } = useSignUpContext();

    useEffect(() => {
        setIsDirectSignUpFlow(true);
    }, [setIsDirectSignUpFlow]);

    return (
        <div className="DirectSignUp">
            <SignUpSection />
            <FeaturesSection />
        </div>
    );
};

export default DirectSignUpPage;
